import { render } from "./SubmittedCard.vue?vue&type=template&id=0b002c09&scoped=true"
import script from "./SubmittedCard.vue?vue&type=script&lang=js"
export * from "./SubmittedCard.vue?vue&type=script&lang=js"

import "./SubmittedCard.vue?vue&type=style&index=0&id=0b002c09&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b002c09"]])

export default __exports__